
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/[garageOrBrand]",
      function () {
        return require("private-next-pages/[city]/[garageOrBrand]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/[garageOrBrand]"])
      });
    }
  